export enum ProductAvailability {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
